// src/pages/TechnicianDashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import backgroundImage from '../assets/TECH-BC.png';
import logo from '../assets/Logo2.png';
import '../App.css'; // خط Poppins
import './TechnicianDashboard.css'; // ✅ استدعاء CSS الخاص

function TechnicianDashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      localStorage.removeItem('userRole');
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Logout failed');
    }
  };

  return (
    <div
      className="technician-dashboard"
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      {/* الهيدر */}
      <div className="dashboard-header">
        <img src={logo} alt="Logo" className="dashboard-logo" />
        <h2 className="dashboard-title">JOB CARD RECORD SYSTEM</h2>
        <button className="logout-btn" onClick={handleLogout}>
          Sign out
        </button>
      </div>

      {/* المحتوى */}
      <div className="dashboard-content">
        <h1 className="dashboard-welcome">Welcome Technician</h1>
        <p className="dashboard-role">You are logged in as technician</p>

        <div className="dashboard-buttons">
          <button
            onClick={() => navigate('/view-job-cards')}
            className="dashboard-btn"
          >
            View all job cards
          </button>
          <button
            onClick={() => navigate('/track-status')}
            className="dashboard-btn"
          >
            Job Card Tracking
          </button>
        </div>
      </div>
    </div>
  );
}

export default TechnicianDashboard;
